import React from 'react';
import { useParams } from 'react-router-dom';
import { PageErrorBoundry } from '../views/ats-details/details-error/details-error';
import { Page } from '../views/ats-pages/page/page';

export function ManagedRoutes() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <PageErrorBoundry>
      <Page slug={slug} />
    </PageErrorBoundry>
  );
}
